import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Divider } from 'components/Divider/Divider';
import { Hide } from 'components/Hide/Hide';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { spacing } from 'theme/theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE } from 'utils/constants/general/listingTypeHumanNameMapTitle';

import { orgHasListings } from './utils/orgHasListings';

type Props = {
  org: ApiOrg;
};

export function ViewOrgPageSidebarHeader({ org }: Props) {
  const jobCount = org.jobs.length;
  const internshipCount = org.internships.length;
  const volopCount = org.volops.length;
  const eventCount = org.events.length;

  const hasListings = orgHasListings(org);

  return (
    <>
      {jobCount > 0 && (
        <Button
          type="link"
          variant="link"
          href="?tab=JOB#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.JOB} Link`,
            });
          }}
        >
          {sprintf(
            jobCount > 1
              ? getText('%(jobCount)s current jobs')
              : getText('%(jobCount)s current job'),
            {
              jobCount,
            },
          )}
        </Button>
      )}
      {internshipCount > 0 && (
        <Button
          type="link"
          variant="link"
          href="?tab=INTERNSHIP#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.INTERNSHIP} Link`,
            });
          }}
        >
          {sprintf(
            internshipCount > 1
              ? getText('%(internshipCount)s current internships')
              : getText('%(internshipCount)s current internship'),
            {
              internshipCount,
            },
          )}
        </Button>
      )}

      {volopCount > 0 && (
        <Button
          type="link"
          variant="link"
          href="?tab=VOLOP#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.VOLOP} Link`,
            });
          }}
        >
          {sprintf(
            volopCount > 1
              ? getText('%(volopCount)s current volunteer opportunities')
              : getText('%(volopCount)s current volunteer opportunity'),
            { volopCount },
          )}
        </Button>
      )}

      {eventCount > 0 && (
        <Button
          type="link"
          variant="link"
          href="?tab=EVENT#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.EVENT} Link`,
            });
          }}
        >
          {sprintf(
            eventCount > 1
              ? getText('%(eventCount)s current events')
              : getText('%(eventCount)s current event'),
            { eventCount },
          )}
        </Button>
      )}

      <Hide xs sm>
        {hasListings && (
          <Box mt={spacing[16]}>
            <Button
              type="link"
              href="#opportunities"
              onClick={() => {
                trackClicked('See Opportunities', { type: 'Button Left' });
              }}
              variant="primary"
            >
              {getText('See opportunities')}
            </Button>
          </Box>
        )}
      </Hide>

      {hasListings ? <Divider marginTop={24} marginBottom={24} /> : null}
    </>
  );
}
